<ng-container *ngIf="(getCount | thunk : page : pageSize : collectionSize) as count">
  {{count}}
</ng-container>
